<script setup lang="ts">
import ListSearchCommon from 'src/components/ListSearchCommon.vue';
import PeopleResult from 'src/components/search-results/PeopleCard.vue';
import PeopleSkeleton from 'src/components/skeleton-loading/PeopleSkeleton.vue';
import { type SearchResultType } from 'src/stores';
import type { PeopleCardData } from 'src/types';

const convertData = (data: SearchResultType) => {
    let result: PeopleCardData = data as PeopleCardData;
    return result;
};
</script>

<template>
    <ListSearchCommon type="people">
        <template #item="{ data }">
            <PeopleResult :data="convertData(data)" />
        </template>

        <template #skeleton-loading>
            <PeopleSkeleton />
        </template>
    </ListSearchCommon>
</template>
